import React from "react";

export default function ({
  label,
  name,
  register,
  options = [],
  errorMessage = "",
  classes = "",
  parentClasses = "",
  firstOption = "",
  required = false,
  disabled = false
}) {
  return (
    <>
      <div className={`fv-row mb-10${parentClasses ? " " + parentClasses : ''}`}>
        <label className="form-label fs-6 fw-bolder text-dark">
          {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
          </label>
        <select
          className={`form-control form-control-lg form-control-solid${classes ? " " + classes : ''}`}
          {...register(name)}
          required={required}
          disabled={disabled}
        >
          <option>{firstOption ? firstOption : "Choose"}</option>
          {options.map((option, index) => (<option value={option?.id} key={index}>{option?.name}</option>))}
        </select>

        {errorMessage && (
          <div className="fv-plugins-message-container invalid-feedback">
            <div>{errorMessage}</div>
          </div>
        )}
      </div>
    </>
  );
}